export { default } from './ExpandFilterLink';



// WEBPACK FOOTER //
// ./app/components/shared/Facets/ExpandFilterLink/index.js